[
  {
    "id": "admin-0001",
    "email": "anna.admin@mail.de",
    "fullname": "Anna Admin",
    "role": "ADMIN",
    "storeGrants": []
  },
  {
    "id": "user-0002",
    "email": "eric.employee@aol.com",
    "fullname": "Eric Employee",
    "role": "USER",
    "storeGrants": [
      {
        "storeId": "8501209d-2281-4b65-8c01-1d2f36f251f0",
        "role": "STORE_EMPLOYEE"
      },
      {
        "storeId": "bde1209d-2281-4b65-8c01-1d2f36f251f0",
        "role": "STORE_EMPLOYEE"
      },
      {
        "storeId": "fff1209d-2281-4b65-8c01-1d2f36f25122",
        "role": "STORE_EMPLOYEE"
      },
      {
        "storeId": "d83f666d-1a36-44ed-a7ed-3293d9f64957",
        "role": "STORE_EMPLOYEE"
      },
      {
        "storeId": "019b1203-5d29-757a-8d50-a5d341ab0850",
        "role": "STORE_EMPLOYEE"
      },
      {
        "storeId": "019b1201-1a19-751a-8d10-a5d341ab0850",
        "role": "STORE_EMPLOYEE"
      },
      {
        "storeId": "019b1201-1a19-751a-8d10-a5d341ab5555",
        "role": "STORE_EMPLOYEE"
      },
      {
        "storeId": "019b1201-1a19-751a-8d10-a5d341bc6666",
        "role": "STORE_EMPLOYEE"
      }
    ]
  },
  {
    "id": "manager-0003",
    "email": "manfred.manager@gmx.de",
    "fullname": "Manfred Manager",
    "role": "USER",
    "storeGrants": [
      {
        "storeId": "8501209d-2281-4b65-8c01-1d2f36f251f0",
        "role": "STORE_MANAGER"
      }
    ]
  },
  {
    "id": "user-0004",
    "email": "notauthenticated.employee@aol.com",
    "fullname": "Not Authenticated",
    "role": "USER",
    "storeGrants": [
      {
        "storeId": "8501209d-2281-4b65-8c01-1d2f36f251f0",
        "role": "USER"
      },
      {
        "storeId": "bde1209d-2281-4b65-8c01-1d2f36f251f0",
        "role": "USER"
      },
      {
        "storeId": "fff1209d-2281-4b65-8c01-1d2f36f25122",
        "role": "USER"
      },
      {
        "storeId": "d83f666d-1a36-44ed-a7ed-3293d9f64957",
        "role": "USER"
      }
    ]
  },
  {
    "id": "user-0005",
    "email": "dennis.developer@cool.ai",
    "fullname": "Dennis Developer",
    "role": "DEVELOPER",
    "storeGrants": [
      {
        "storeId": "fff1209d-2281-4b65-8c01-1d2f36f25122",
        "role": "STORE_MANAGER"
      },
      {
        "storeId": "019b1201-1a19-751a-8d10-a5d341ab5555",
        "role": "STORE_EMPLOYEE"
      }
    ]
  },
  {
    "id": "viewer-0006",
    "email": "vera.viewer@demo.local",
    "fullname": "Vera Viewer",
    "role": "VIEWER",
    "storeGrants": []
  },
  {
    "id": "contributor-0007",
    "email": "carl.contributor@demo.local",
    "fullname": "Carl Contributor",
    "role": "CONTRIBUTOR",
    "storeGrants": []
  }
]